<template>
  <div class="page-box">
    <div class="info-box">
      <div class="confirm-info">
        <div class="icon-box">
          <img src="@/assets/img/filing/ok.png" width="100%" alt="">
        </div>
        <div class="title">电子核验完毕</div>
      </div>
    </div>
    <div class="msg-box">
        <span class="text">
          恭喜您，全部核验完成，请返回PC端查看并确认提交核准
        </span>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      from:{
      }
    };
  },
  methods: {
  }
};
</script>
<style lang="scss" scoped>
.page-box {
  max-width: 750px;
  margin: auto;
  padding: 50px;
  .info-box{
    padding-top: 100px;
    .confirm-info{
      .title{
        margin-top: 70px ;
        margin-bottom: 50px ;
        font-weight: bold;
        font-size: 32px;
        text-align: center;
      }
      .icon-box{
        width: 30%;
        margin: auto;
      }
    }
  }
  .msg-box{
    margin: 100px 0 ;
      .text{
        flex: 1;
        line-height: 50px;
        font-size: 28px;
      }
  }
}
</style>
